export const getCDNUrl = (suffix: string) => {
  // if (process.env.NEXT_PUBLIC_STAGE === 'development') {
  //   return 'https://dev-cdn.neverse.fun/' + suffix
  // }
  return 'https://neverse-cdn.youyoudeer.com/' + suffix
}
